import * as prismic from '@prismicio/client';
import * as prismicNext from '@prismicio/next';
import config from '../slicemachine.config.json';

import { PRODUCTION } from '@/utils';

/**
 * The project's Prismic repository name.
 */
export const repositoryName =
  process.env.NEXT_PUBLIC_PRISMIC_ENVIRONMENT || config.repositoryName;

/**
 * A list of Route Resolver objects that define how a document's `url` field is resolved.
 *
 * {@link https://prismic.io/docs/route-resolver#route-resolver}
 */
// TODO: Update the routes array to match your project's route structure.
const routes: prismic.ClientConfig['routes'] = [
  {
    type: 'page',
    uid: 'home',
    path: '/',
  },
  {
    type: 'page',
    path: '/:parent?/:uid',
    resolvers: {
      parent: 'parent_page',
    },
  },
  {
    type: 'blog_home_layout',
    path: '/blog',
  },
  {
    type: 'blog',
    path: '/blog/:uid',
  },
  {
    type: 'case_study',
    path: '/clients/:uid',
  },
  {
    type: 'ebook',
    path: '/ebooks/:uid',
  },
  {
    type: 'landing',
    path: '/landing/:uid',
  },
  {
    type: 'get_started',
    uid: 'get-started',
    path: '/get-started',
  },
  {
    type: 'get_started',
    path: '/get-started/:uid',
  },
];

/**
 * Creates a Prismic client for the project's repository. The client is used to
 * query content from the Prismic API.
 *
 * @param configParam
 */
export const createClient = (
  configParam: prismicNext.CreateClientConfig = {},
) => {
  const client = prismic.createClient(repositoryName, {
    routes,
    fetchOptions:
      process.env.NODE_ENV === PRODUCTION
        ? { next: { revalidate: 300 } }
        : { next: { revalidate: 5 } },
    // Reduce page size to prevent cache size issues
    defaultParams: {
      pageSize: 20,
    },
    // The `...configParam` spread is important. If `configParam.previewData` exists
    // and contains a `ref`, that `ref` will be passed to `prismic.createClient`,
    // making the client instance "preview-aware".
    ...configParam,
  });

  prismicNext.enableAutoPreviews({
    client,
    // previewData: configParam.previewData, // REMOVED: This line caused the type error.
    // The client is already preview-aware if configParam.previewData.ref was passed above.
    // req: configParam.req,
  });

  return client;
};
